(() => {
  'use strict';
  function init() {
    const root = document.querySelector('[data-onair-cart-fitment]');
    if (!root || root.dataset.onairFitmentBound) return;
    root.dataset.onairFitmentBound = 'true';
    const handles = new Set(['air-bags-suspension', 'performance-air-bag-suspension', 'front-set-only-performance-air-bag-suspension', 'rear-set-only-performance-air-bag-suspension', 'onair-air-bags', 'onair-coilovers', 'onair-performance-coilover-sponsor-link','onair-essential-complete-air-ride-kit','onair-street-complete-air-ride-kit','onair-elite-complete-air-ride-kit']);
    const fields = [...root.querySelectorAll('[data-fitment-required]')];
    const allFields = [...root.querySelectorAll('input')];
    let frame = 0;
    let lastState;
    function needsFitment() {
      return [...document.querySelectorAll('#main-cart .cart-product-item [cart-item-name]')].some(link => {
        try { return handles.has(new URL(link.href, location.href).pathname.split('/products/')[1]?.split('/')[0]); }
        catch { return false; }
      });
    }
    function ready() { return fields.every(input => input.value.trim() && input.validity.valid); }
    function update() {
      frame = 0;
      const needs = needsFitment();
      root.hidden = !needs;
      allFields.forEach(input => { input.disabled = !needs; });
      const complete = !needs || ready();
      document.documentElement.classList.toggle('onair-fitment-required', needs);
      document.documentElement.classList.toggle('onair-fitment-incomplete', !complete);
      const checkout = document.querySelector('#MainContent #cartCheckout');
      if (checkout) {
        if (checkout.dataset.onairFitmentBlocked) {
          delete checkout.dataset.onairFitmentBlocked;
          checkout.disabled = false;
          checkout.removeAttribute('aria-disabled');
        }
        let hint = checkout.parentElement?.querySelector('[data-onair-fitment-hint]');
        if (!hint) {
          hint = document.createElement('p');
          hint.id = 'onair-cart-checkout-hint';
          hint.className = 'onair-v62-checkout-hint';
          hint.dataset.onairFitmentHint = 'true';
          hint.setAttribute('role', 'status');
          hint.setAttribute('aria-live', 'polite');
          checkout.insertAdjacentElement('afterend', hint);
        }
        hint.hidden = complete;
        if (!complete) hint.textContent = root.dataset.requiredCopy || 'Enter your vehicle details to check out.';
        checkout.setAttribute('aria-describedby', hint.id);
      }
      const status = root.querySelector('[data-fitment-status]');
      status?.classList.toggle('ready', complete);
      const title = root.querySelector('[data-fitment-status-title]');
      const copy = root.querySelector('[data-fitment-status-copy]');
      const titleText = complete ? root.dataset.readyTitle : root.dataset.requiredTitle;
      const copyText = complete ? root.dataset.readyCopy : root.dataset.requiredCopy;
      if (title && title.textContent !== titleText) title.textContent = titleText;
      if (copy && copy.textContent !== copyText) copy.textContent = copyText;
      const state = String(needs) + ':' + String(complete);
      if (lastState !== state) {
        lastState = state;
        document.dispatchEvent(new CustomEvent('onair:fitment-changed'));
      }
    }
    const queue = () => { if (!frame) frame = requestAnimationFrame(update); };
    function guard(event) {
      if (!needsFitment() || ready()) return;
      if (event.type === 'submit' && event.target !== document.querySelector('#MainContent form#cart')) return;
      if (event.type === 'submit' && event.submitter && event.submitter.name !== 'checkout') return;
      if (event.type === 'click' && !event.target.closest('#MainContent #cartCheckout')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const field = fields.find(input => !input.value.trim() || !input.validity.valid);
      field?.focus({preventScroll:true});
      root.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
      field?.reportValidity();
    }
    root.addEventListener('input', queue);
    root.addEventListener('change', queue);
    document.addEventListener('submit', guard, true);
    document.addEventListener('click', guard, true);
    document.addEventListener('shopify:section:load', queue);
    window.addEventListener('pageshow', queue);
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(records => {
      if (records.some(record => !root.contains(record.target))) queue();
    }).observe(main, {subtree:true, childList:true, attributes:true, attributeFilter:['data-item-count']});
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
